export enum AgreementItemTypes {
  BLOB_SETTINGS = 'Blob Settings',
  PRODUCT = 'Product',
  VIDEO_COMMERCIAL = 'Video Commercial',
  POSTER = 'Poster',
  PRODUCT_PURCHASE = 'Product Purchase'
}

export enum AgreementItemPropertyTypes {
  BLOB_TRIGGERED = 'BLOB TRIGGERED',
  MAX_ATTACH_TIME_SECONDS = 'MAX ATTACH TIME SECONDS',
  PRICE_PER_TIME_ON_SCREEN_ATTACHED = 'PRICE PER TIME ON SCREEN ATTACHED',
  PRICE_PER_TIME_ON_SCREEN_DETACHED = 'PRICE PER TIME ON SCREEN DETACHED',
  MINIMUM_TIME_IN_STACK = 'MINIMUM TIME IN STACK',
  MAXIMUM_TIME_IN_STACK = 'MAXIMUM TIME IN STACK',
  PRODUCT_PAGE_OPENED_FROM_BLOB = 'PRODUCT PAGE OPENED FROM BLOB',
  PRODUCT_ADDED_TO_CART = 'PRODUCT ADDED TO CART',
  PRICE_PER_VIDEO_PLAYBACK = 'PRICE PER VIDEO PLAYBACK',
  PRICE_PER_CLICK = 'PRICE PER CLICK',
  PRICE_PER_TIME_ON_SCREEN = 'PRICE PER TIME ON SCREEN',
  PURCHASE_FEE = 'PURCHASE FEE'
}

export type AgreementPropertiesType = { [key in AgreementItemPropertyTypes]?: number }

export interface AgreementItemDTO {
  id: number
  type: AgreementItemTypes
  properties: AgreementPropertiesType
}
export class AgreementItem {
  id: number
  type: AgreementItemTypes
  properties: AgreementPropertiesType

  constructor (item: AgreementItem) {
    for (const property in item) {
      this[property] = item[property]
    }
  }
}
